import jwtDecode from 'jwt-decode'
import configureStore from '../store/index'
import { UserRemove } from '../modules/auths/actions'
import Cookies from './cookies'
import { JWT_PUBLISHER } from './user'

export const clearUser = () => {
  localStorage.removeItem('persist:root')
  Cookies.set(JWT_PUBLISHER, '')
  const reduxStore = configureStore()
  reduxStore &&
    reduxStore.store.dispatch(UserRemove.request({ userIns: 'currentUser' }))
}

export const checkTokenExpiredTime = token => {
  try {
    if (!token) return
    const user = jwtDecode(token)
    const d = new Date()
    if (user.exp < d / 1000) {
      clearUser()
    }
  } finally {
  }
}
